  <template>

      <div id="app">
      <router-view v-wechat-title="$route.meta.title"/>
      </div>
    </template>

<script>

import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import MenuList from './components/menu.vue'
import Header from './components/head.vue'
import CKEditor from 'ckeditor4-vue'

Vue.use(Element)
Vue.use(MenuList)
Vue.use(Header)
Vue.use(CKEditor)

// Vue.use(MetaInfo) //SEO

export default {
  name: 'app',
  data: function () {
    return {
      active: true
    }
  },
  methods: {
    test () {
      // console.log('hello')
      this.$router.push('/')
    }
  },
   mounted () {
      const script = document.createElement('script')
      script.src = 'https://s4.cnzz.com/z_stat.php?id=1279532325&web_id=1279532325'
      script.language = 'JavaScript'
      document.body.appendChild(script)

      // seo优化使用
      document.dispatchEvent(new Event('render-event'))
    },
    watch: {
      '$route' () {
        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
      }
    }
}
</script>

    <style>
      body{margin: 0;}
    #app {
      min-width: 1200px;
      margin: 0 auto;
      font-family: "Helvetica Neue","PingFang SC",Arial,sans-serif;
    }
    /* 头部导航 */
    header{z-index: 1000;min-width: 1200px;transition: all 0.5s ease;  border-top: solid 4px #3091F2;  background-color: #fff;  box-shadow: 0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04);  }
    header.header-fixed{position: fixed;top: 0;left: 0;right: 0;}
    header .el-menu-demo{padding-left: 300px!important;}

    /* 主内容区 */
      main{    display: -webkit-box;  display: -ms-flexbox;  display: flex;  min-height: 800px;  border: solid 40px #E9ECF1;  background-color: #FCFCFC;  }
      main .main-left{text-align: center;width: 200px;float: left;}
      main .main-right{-webkit-box-flex: 1;  -ms-flex: 1;  flex: 1;  background-color: #fff; padding: 50px 70px; }
      main .el-menu{background-color: transparent!important;}
    </style>



// WEBPACK FOOTER //
// src/App.vue